import { cn } from "@/lib/cn";

type Size = "xs" | "sm" | "md";

type Props = {
  size?: Size;
  className?: string;
  /** Accessible label (défaut : activité en cours). */
  label?: string;
};

/**
 * Indicateur d’activité journal — pulse doux (pas de spinner qui mouline).
 * Inspiration type “live / processing” plutôt que “chargement bloqué”.
 */
export function MailActivityIndicator({
  size = "md",
  className,
  label = "Traitement en cours",
}: Props) {
  return (
    <span
      className={cn("mail-activity-pulse", `mail-activity-pulse--${size}`, className)}
      role="status"
      aria-label={label}
    >
      <span className="mail-activity-pulse__ring" aria-hidden />
      <span className="mail-activity-pulse__core" aria-hidden />
    </span>
  );
}
